/* SudoSecurity reading + UI enhancements. No dependencies. */
(function () {
    'use strict';

    var doc = document;
    var root = doc.documentElement;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
    function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

    function slugify(text) {
        return text.toLowerCase().trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '') || 'section';
    }

    /* Theme toggle ------------------------------------------------------- */
    var THEME_MODES = ['dark', 'light', 'auto'];
    function storedMode() {
        try { var t = localStorage.getItem('sudo-theme'); if (THEME_MODES.indexOf(t) > -1) return t; } catch (e) { /* storage disabled */ }
        if (root.classList.contains('theme-light')) return 'light';
        if (root.classList.contains('theme-dark')) return 'dark';
        return 'auto';
    }
    var themeMeta = $('meta[name="theme-color"]');
    var prefersLight = window.matchMedia('(prefers-color-scheme: light)');
    function syncThemeColor() {
        if (!themeMeta) return;
        var light = root.classList.contains('theme-light') || (root.classList.contains('theme-auto') && prefersLight.matches);
        themeMeta.setAttribute('content', light ? '#ffffff' : '#000000');
    }
    syncThemeColor();
    if (prefersLight.addEventListener) prefersLight.addEventListener('change', syncThemeColor);
    function applyMode(btn, mode) {
        root.classList.remove('theme-dark', 'theme-light', 'theme-auto');
        root.classList.add('theme-' + mode);
        btn.setAttribute('data-mode', mode);
        btn.setAttribute('aria-label', 'Colour theme: ' + mode + ' (click to change)');
        btn.setAttribute('title', 'Theme: ' + mode);
        syncThemeColor();
    }
    $$('[data-theme-toggle]').forEach(function (btn) {
        applyMode(btn, storedMode());
        btn.addEventListener('click', function () {
            var next = THEME_MODES[(THEME_MODES.indexOf(storedMode()) + 1) % THEME_MODES.length];
            applyMode(btn, next);
            try { localStorage.setItem('sudo-theme', next); } catch (e) { /* storage disabled */ }
        });
    });

    /* "/" focuses search ------------------------------------------------- */
    doc.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        var btn = $('[data-ghost-search]');
        if (btn) { e.preventDefault(); btn.click(); }
    });

    /* Header shadow once scrolled ---------------------------------------- */
    var head = $('.gh-head');
    if (head && 'IntersectionObserver' in window) {
        var sentinel = doc.createElement('div');
        sentinel.className = 'scroll-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        doc.body.insertBefore(sentinel, doc.body.firstChild);
        new IntersectionObserver(function (entries) {
            head.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        }).observe(sentinel);
    }

    /* Share / copy link -------------------------------------------------- */
    function flash(btn, text) {
        var label = btn.querySelector('span');
        if (!label) return;
        var prev = label.textContent;
        label.textContent = text;
        btn.classList.add('is-done');
        setTimeout(function () { label.textContent = prev; btn.classList.remove('is-done'); }, 1800);
    }
    function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
        return new Promise(function (resolve, reject) {
            var ta = doc.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            doc.body.appendChild(ta);
            ta.select();
            try { doc.execCommand('copy') ? resolve() : reject(); } catch (err) { reject(err); }
            doc.body.removeChild(ta);
        });
    }
    $$('[data-share]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var url = btn.getAttribute('data-url') || location.href;
            var title = btn.getAttribute('data-title') || doc.title;
            if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
                navigator.share({title: title, url: url}).catch(function () {});
                return;
            }
            copyText(url).then(function () { flash(btn, 'Copied'); }, function () { flash(btn, 'Copy failed'); });
        });
    });

    /* 404: show the path that failed ------------------------------------- */
    var errPath = $('[data-error-path]');
    if (errPath) errPath.textContent = '.' + location.pathname;

    /* "New" badges on posts published in the last 7 days ---------------- */
    $$('.post-card-new[data-published]').forEach(function (b) {
        var ts = parseInt(b.getAttribute('data-published'), 10);
        if (ts && (Date.now() / 1000 - ts) < 7 * 86400) b.hidden = false;
    });

    /* Ctrl+K command palette — terminal-styled jump-to-anywhere ---------- */
    (function initCommandPalette() {
        var keyScript = doc.querySelector('script[data-key]');
        var apiKey = keyScript ? keyScript.getAttribute('data-key') : '';
        var apiBase = (location.origin + '/ghost/api/content/');

        var overlay = doc.createElement('div');
        overlay.className = 'cmdk-overlay';
        overlay.hidden = true;
        overlay.innerHTML =
            '<div class="window cmdk-window" role="dialog" aria-modal="true" aria-label="Command palette">' +
                '<div class="window-bar"><i></i><i></i><i></i><span class="window-title">~/sudosecurity — find</span></div>' +
                '<div class="window-body cmdk-body">' +
                    '<p class="term-line cmdk-prompt"><span class="term-prompt">$</span> sudo find <input class="cmdk-input" type="text" placeholder="articles, sections, pages…" aria-label="Search the site" autocomplete="off" spellcheck="false"></p>' +
                    '<ol class="cmdk-list" role="listbox"></ol>' +
                    '<p class="cmdk-foot"><kbd>↑↓</kbd> navigate <kbd>⏎</kbd> open <kbd>esc</kbd> close</p>' +
                '</div>' +
            '</div>';
        doc.body.appendChild(overlay);
        var input = $('.cmdk-input', overlay);
        var list = $('.cmdk-list', overlay);
        var items = [];
        var active = 0;
        var debounce = null;

        var STATICS = [
            { title: 'Home', slug: '/', kind: 'page' },
            { title: 'About', slug: '/about/', kind: 'page' },
            { title: 'Topics', slug: '/topics/', kind: 'page' },
            { title: 'Forums', slug: '/forums/', kind: 'page' },
            { title: 'Archives', slug: '/archives/', kind: 'page' },
            { title: 'Meet the team', slug: '/meet-the-team/', kind: 'page' },
            { title: 'Forum Archaeology', slug: '/forum-archaeology/', kind: 'series' },
            { title: 'Minecraft Mondays', slug: '/minecraft-mondays/', kind: 'series' },
            { title: 'Self Host Saturday', slug: '/self-host-saturday/', kind: 'series' }
        ];

        function esc(s) { var d = doc.createElement('span'); d.textContent = s; return d.innerHTML; }
        function row(it, i) {
            return '<li role="option" class="cmdk-item' + (i === active ? ' is-active' : '') + '" data-i="' + i + '">' +
                '<span class="cmdk-kind">' + (it.kind === 'post' ? '$' : it.kind === 'series' ? '≡' : '▸') + '</span>' +
                '<span class="cmdk-title">' + esc(it.title) + '</span>' +
                '<span class="cmdk-slug">' + esc(it.slug) + '</span></li>';
        }
        function render() {
            list.innerHTML = items.length ? items.map(row).join('') : '<li class="cmdk-empty">no matches</li>';
        }
        function open() {
            overlay.hidden = false;
            doc.body.classList.add('cmdk-open');
            run('');
            setTimeout(function () { input.focus(); }, 0);
        }
        function close() {
            overlay.hidden = true;
            doc.body.classList.remove('cmdk-open');
            input.value = '';
        }
        function go(it) { if (it) location.href = it.slug.charAt(0) === '/' ? it.slug : '/' + it.slug + '/'; }

        function run(q) {
            q = q.trim();
            var local = STATICS.filter(function (s) { return !q || s.title.toLowerCase().indexOf(q.toLowerCase()) > -1; });
            items = local.slice();
            active = 0;
            render();
            if (!apiKey || !q) return;
            var url = apiBase + 'posts/?key=' + apiKey + '&limit=6&fields=title,slug&filter=' +
                encodeURIComponent("title:~'" + q.replace(/'/g, '') + "'");
            fetch(url).then(function (r) { return r.json(); }).then(function (data) {
                (data.posts || []).forEach(function (p) { items.push({ title: p.title, slug: p.slug, kind: 'post' }); });
                render();
            }).catch(function () { /* offline/API down: statics still work */ });
            fetch(apiBase + 'tags/?key=' + apiKey + '&limit=4&fields=name,slug&filter=' +
                encodeURIComponent("visibility:public+name:~'" + q.replace(/'/g, '') + "'"))
                .then(function (r) { return r.json(); }).then(function (data) {
                    (data.tags || []).forEach(function (t) { items.push({ title: t.name, slug: 'tag/' + t.slug, kind: 'section' }); });
                    render();
                }).catch(function () {});
        }

        doc.addEventListener('keydown', function (e) {
            if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
                e.preventDefault();
                if (overlay.hidden) open(); else close();
                return;
            }
            if (overlay.hidden) return;
            if (e.key === 'Escape') { e.preventDefault(); close(); }
            else if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, items.length - 1); render(); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); render(); }
            else if (e.key === 'Enter') { e.preventDefault(); go(items[active]); }
        });
        input.addEventListener('input', function () {
            clearTimeout(debounce);
            debounce = setTimeout(function () { run(input.value); }, 180);
        });
        list.addEventListener('click', function (e) {
            var li = e.target.closest('.cmdk-item');
            if (li) go(items[parseInt(li.getAttribute('data-i'), 10)]);
        });
        overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    })();

    /* Ghost search (sodo-search) dark mode — same srcdoc-iframe trick as
       Portal: inject overrides into the frame's own document. ---------- */
    (function initSearchDark() {
        var STYLE_ID = 'sudo-search-dark';
        var DARK_CSS =
            'body{background:#0d0d0d!important}' +
            '.bg-white{background:#141414!important}' +
            '.bg-neutral-100{background:#1c1c1c!important}' +
            '.bg-neutral-200{background:#262626!important}' +
            '.bg-neutral-300{background:#2e2e2e!important}' +
            '.text-black,.text-neutral-900{color:#ededed!important}' +
            '.text-neutral-800{color:#d4d4d4!important}' +
            '.text-neutral-700{color:#b3b3b3!important}' +
            '.text-neutral-600{color:#8f8f8f!important}' +
            '.text-neutral-500,.text-neutral-400{color:#7a7a7a!important}' +
            '.border-gray-200,.border-neutral-100,.border-neutral-200{border-color:#262626!important}' +
            'input{color:#ededed!important;background:#0d0d0d!important;border-color:#2e2e2e!important}' +
            'input::placeholder{color:#616161!important}' +
            '.shadow-2xl,.shadow-xl,.shadow-lg{box-shadow:0 25px 50px -12px rgba(0,0,0,.75)!important}';

        function siteDark() {
            if (root.classList.contains('theme-dark')) return true;
            if (root.classList.contains('theme-light')) return false;
            return !prefersLight.matches;
        }
        function isSearchFrame(f) {
            if (f.closest && f.closest('#sodo-search-root')) return true;
            try {
                var d = f.contentDocument;
                return !!(d && d.querySelector('.ghost-display'));
            } catch (e) { return false; }
        }
        function syncFrame(f) {
            try {
                var d = f.contentDocument;
                if (!d || !d.head) return;
                var have = d.getElementById(STYLE_ID);
                if (siteDark()) {
                    if (!have) {
                        var st = d.createElement('style');
                        st.id = STYLE_ID;
                        st.textContent = DARK_CSS;
                        d.head.appendChild(st);
                    }
                } else if (have) have.remove();
            } catch (e) { /* cross-origin */ }
        }
        function onIframe(f) {
            var tries = 0;
            var iv = setInterval(function () {
                tries++;
                try {
                    var d = f.contentDocument;
                    if (d && d.head && isSearchFrame(f)) { syncFrame(f); clearInterval(iv); }
                } catch (e) { /* not ready */ }
                if (tries > 60) clearInterval(iv);
            }, 250);
        }
        $$('iframe').forEach(onIframe);
        new MutationObserver(function (muts) {
            muts.forEach(function (m) {
                Array.prototype.forEach.call(m.addedNodes, function (n) {
                    if (n.tagName === 'IFRAME') onIframe(n);
                    else if (n.querySelectorAll) $$('iframe', n).forEach(onIframe);
                });
            });
        }).observe(doc.documentElement, { childList: true, subtree: true });
        new MutationObserver(function () {
            $$('iframe').forEach(function (f) { if (isSearchFrame(f)) syncFrame(f); });
        }).observe(root, { attributes: true, attributeFilter: ['class'] });
        if (prefersLight.addEventListener) prefersLight.addEventListener('change', function () {
            $$('iframe').forEach(function (f) { if (isSearchFrame(f)) syncFrame(f); });
        });
    })();

    /* Reading progress bar on articles ----------------------------------- */
    if (doc.body && doc.body.classList.contains('post-template')) {
        var bar = doc.createElement('div');
        bar.className = 'read-progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.innerHTML = '<i></i>';
        doc.body.appendChild(bar);
        var fill = bar.firstChild;
        var ticking = false;
        function paintProgress() {
            ticking = false;
            var max = root.scrollHeight - window.innerHeight;
            fill.style.width = (max > 0 ? Math.min(1, window.scrollY / max) * 100 : 0) + '%';
        }
        window.addEventListener('scroll', function () {
            if (!ticking) { ticking = true; requestAnimationFrame(paintProgress); }
        }, { passive: true });
        paintProgress();
    }

    /* Trending this week — static JSON written hourly from Umami --------- */
    (function initTrending() {
        var section = $('[data-trending]');
        var list = $('[data-trending-list]');
        if (!section || !list) return;
        fetch('/trending.json').then(function (r) { return r.ok ? r.json() : null; }).then(function (items) {
            if (!items || !items.length) return;
            list.innerHTML = items.slice(0, 5).map(function (it, i) {
                return '<li><a href="' + escAttr('/' + it.slug + '/') + '">' +
                    '<span class="trending-rank">' + String(i + 1).padStart(2, '0') + '</span>' +
                    '<span class="trending-title">' + escHtml(it.title) + '</span>' +
                    '<span class="trending-views">' + it.views + ' views</span></a></li>';
            }).join('');
            section.hidden = false;
        }).catch(function () { /* no data yet */ });
        function escHtml(s) { var d = doc.createElement('span'); d.textContent = s; return d.innerHTML; }
        function escAttr(s) { return s.replace(/"/g, '&quot;'); }
    })();

    /* Portal (members) dark mode -----------------------------------------
       Portal renders its trigger + popup into same-origin srcdoc iframes
       our stylesheet can't reach, so inject a <style> into the popup's
       document. Only the popup needs the palette flip (the trigger button
       is accent-on-accent already). Vars redefined on the iframe's <body>
       beat Portal's own :root values for everything inside it. */
    (function initPortalDark() {
        var STYLE_ID = 'sudo-portal-dark';
        var DARK_CSS =
            'body{' +
            '--white:#0d0d0d;--whitergb:13,13,13;--black:#ededed;' +
            '--grey0:#f0f0f0;--grey1:#e8e8e8;--grey2:#d4d4d4;--grey3:#c4c4c4;' +
            '--grey4:#b3b3b3;--grey5:#a1a1a1;--grey6:#8f8f8f;--grey7:#7a7a7a;' +
            '--grey8:#616161;--grey9:#474747;--grey10:#383838;--grey11:#2e2e2e;' +
            '--grey12:#262626;--grey13:#141414;--grey13rgb:20,20,20;--grey14:#1d1d1d;' +
            '--grey1rgb:232,232,232;}' +
            /* Text/icons on accent or red backgrounds stay real white. */
            '.gh-portal-triggerbtn-label,' +
            '.gh-portal-for-switch .input-toggle-component::before,' +
            '.gh-portal-btn-product:not(.gh-portal-btn-unsubscribe) .gh-portal-btn,' +
            '.gh-portal-datepicker-selected .gh-portal-datepicker-day-button,' +
            '.gh-portal-gift-checkout-card-duration,' +
            '.gh-portal-gift-checkout-card-tier,' +
            '.gh-portal-gift-checkout-card-detail-value,' +
            '.gh-portal-gift-email-from,' +
            '.gh-portal-gift-success-copy,' +
            '.gh-portal-share-action.copy,' +
            '.gh-portal-share-label,' +
            '.gh-portal-cookiebanner{color:#fff!important}' +
            '.gh-portal-loadingicon path,.gh-portal-loadingicon rect{fill:#fff!important}' +
            '.gh-portal-datepicker-selected .gh-portal-datepicker-day-button::after{background:#fff!important}' +
            /* Hardcoded light-mode values inside the Portal bundle. */
            '.gh-portal-publication-title{color:var(--grey1)!important}' +
            '.gh-portal-products-pricetoggle{background:#1c1c1c!important}' +
            '.gh-portal-recommendation-arrow-icon path{stroke:var(--grey6)!important}';

        function siteDark() {
            if (root.classList.contains('theme-dark')) return true;
            if (root.classList.contains('theme-light')) return false;
            return !prefersLight.matches;
        }
        function isPopupFrame(f) {
            if ((f.className || '').indexOf('triggerbtn') > -1) return false;
            if (f.title === 'portal-popup') return true;
            try {
                var d = f.contentDocument;
                return !!(d && d.querySelector('.gh-portal-popup-container'));
            } catch (e) { return false; }
        }
        function syncFrame(f) {
            try {
                var d = f.contentDocument;
                if (!d || !d.head) return;
                var have = d.getElementById(STYLE_ID);
                if (siteDark()) {
                    if (!have) {
                        var st = d.createElement('style');
                        st.id = STYLE_ID;
                        st.textContent = DARK_CSS;
                        d.head.appendChild(st);
                    }
                } else if (have) {
                    have.remove();
                }
            } catch (e) { /* cross-origin */ }
        }
        function onIframe(f) {
            /* The popup's app renders a couple of seconds after the iframe
               element appears; poll briefly until its document exists. */
            var tries = 0;
            var iv = setInterval(function () {
                tries++;
                try {
                    var d = f.contentDocument;
                    if (d && d.head && isPopupFrame(f)) {
                        syncFrame(f);
                        clearInterval(iv);
                    }
                } catch (e) { /* not ready */ }
                if (tries > 60) clearInterval(iv);
            }, 250);
        }
        $$('iframe').forEach(onIframe);
        new MutationObserver(function (muts) {
            muts.forEach(function (m) {
                Array.prototype.forEach.call(m.addedNodes, function (n) {
                    if (n.tagName === 'IFRAME') onIframe(n);
                    else if (n.querySelectorAll) $$('iframe', n).forEach(onIframe);
                });
            });
        }).observe(doc.documentElement, { childList: true, subtree: true });
        /* Theme switch while a popup is open. */
        new MutationObserver(function () {
            $$('iframe').forEach(function (f) { if (isPopupFrame(f)) syncFrame(f); });
        }).observe(root, { attributes: true, attributeFilter: ['class'] });
        if (prefersLight.addEventListener) prefersLight.addEventListener('change', function () {
            $$('iframe').forEach(function (f) { if (isPopupFrame(f)) syncFrame(f); });
        });
    })();


    var content = $('.post-template .gh-content, .page-template .gh-content');
    if (!content) return;

    /* Heading anchors ---------------------------------------------------- */
    var used = {};
    var headings = $$('h2, h3', content).filter(function (h) { return !h.closest('.kg-card, blockquote, aside'); });
    headings.forEach(function (h) {
        if (!h.id) {
            var base = slugify(h.textContent);
            var id = base, n = 2;
            while (used[id] || doc.getElementById(id)) id = base + '-' + n++;
            h.id = id;
        }
        used[h.id] = true;
        var a = doc.createElement('a');
        a.className = 'heading-anchor';
        a.href = '#' + h.id;
        a.setAttribute('aria-label', 'Link to section: ' + h.textContent.trim());
        a.textContent = '#';
        h.appendChild(a);
    });

    /* Reading progress --------------------------------------------------- */
    var bar = $('.read-progress span');
    if (bar) {
        var ticking = false;
        var update = function () {
            var rect = content.getBoundingClientRect();
            var total = rect.height - window.innerHeight * 0.6;
            var pct = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
            bar.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
            ticking = false;
        };
        window.addEventListener('scroll', function () {
            if (!ticking) { ticking = true; requestAnimationFrame(update); }
        }, {passive: true});
        window.addEventListener('resize', update, {passive: true});
        update();
    }

    /* Code blocks: language label, copy, lazy highlight ------------------ */
    var LANG_NAMES = {js: 'JavaScript', javascript: 'JavaScript', ts: 'TypeScript', typescript: 'TypeScript', py: 'Python', python: 'Python', sh: 'Shell', bash: 'Bash', shell: 'Shell', zsh: 'Zsh', console: 'Console', html: 'HTML', xml: 'XML', css: 'CSS', scss: 'SCSS', json: 'JSON', yaml: 'YAML', yml: 'YAML', toml: 'TOML', ini: 'INI', sql: 'SQL', go: 'Go', golang: 'Go', rust: 'Rust', rs: 'Rust', java: 'Java', kotlin: 'Kotlin', c: 'C', cpp: 'C++', 'c++': 'C++', csharp: 'C#', cs: 'C#', php: 'PHP', ruby: 'Ruby', rb: 'Ruby', swift: 'Swift', lua: 'Lua', dockerfile: 'Dockerfile', docker: 'Dockerfile', nginx: 'nginx', powershell: 'PowerShell', ps1: 'PowerShell', diff: 'Diff', makefile: 'Makefile', plaintext: 'Text', text: 'Text', markdown: 'Markdown', md: 'Markdown', graphql: 'GraphQL'};
    var blocks = $$('pre', content).filter(function (pre) { return pre.querySelector('code') && !pre.closest('.code-block'); });
    var needsHighlight = [];

    blocks.forEach(function (pre) {
        var code = pre.querySelector('code');
        var m = (code.className || '').match(/(?:^|\s)lang(?:uage)?-([\w+#-]+)/i);
        var lang = m ? m[1].toLowerCase() : '';

        var wrap = doc.createElement('div');
        wrap.className = 'code-block';
        var headBar = doc.createElement('div');
        headBar.className = 'code-block-head';
        var label = doc.createElement('span');
        label.className = 'code-block-lang';
        label.textContent = LANG_NAMES[lang] || (lang ? lang : 'code');
        var btn = doc.createElement('button');
        btn.type = 'button';
        btn.className = 'code-block-copy';
        btn.setAttribute('aria-label', 'Copy code to clipboard');
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 012-2h10"/></svg><span>Copy</span>';
        btn.addEventListener('click', function () {
            copyText(code.innerText).then(function () { flash(btn, 'Copied'); }, function () { flash(btn, 'Failed'); });
        });
        headBar.appendChild(label);
        headBar.appendChild(btn);

        pre.parentNode.insertBefore(wrap, pre);
        wrap.appendChild(headBar);

        var body = doc.createElement('div');
        body.className = 'code-body';
        wrap.appendChild(body);
        body.appendChild(pre);
        pre.setAttribute('tabindex', '0');

        /* Line-number gutter (numbers stay pinned while code scrolls) ---- */
        var raw = code.textContent.replace(/\n$/, '');
        var lineCount = raw === '' ? 0 : raw.split('\n').length;
        if (lineCount > 1) {
            var gutter = doc.createElement('span');
            gutter.className = 'code-gutter';
            gutter.setAttribute('aria-hidden', 'true');
            for (var ln = 1; ln <= lineCount; ln++) {
                var gi = doc.createElement('i');
                gi.textContent = ln;
                gutter.appendChild(gi);
            }
            body.insertBefore(gutter, pre);
            wrap.classList.add('has-lines');
        }

        /* Diff: tint whole lines ourselves instead of the highlighter --- */
        if (lang === 'diff') {
            var dlines = code.textContent.replace(/\n$/, '').split('\n');
            code.textContent = '';
            dlines.forEach(function (l, i) {
                var s = doc.createElement('span');
                var first = l.charAt(0);
                s.className = 'diff-line' + (first === '+' ? ' diff-add' : first === '-' ? ' diff-del' : first === '@' ? ' diff-hunk' : '');
                s.textContent = l;
                code.appendChild(s);
                if (i < dlines.length - 1) code.appendChild(doc.createTextNode('\n'));
            });
        }

        if (lang && lang !== 'plaintext' && lang !== 'text' && lang !== 'diff' && !code.classList.contains('hljs') && !code.querySelector('.token')) needsHighlight.push(code);
    });

    if (needsHighlight.length) {
        var src = doc.body.getAttribute('data-highlight-src');
        var loaded = false;
        var load = function () {
            if (loaded || !src) return;
            loaded = true;
            var s = doc.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = function () {
                if (!window.hljs) return;
                window.hljs.configure({ignoreUnescapedHTML: true});
                needsHighlight.forEach(function (c) {
                    var m2 = c.className.match(/lang(?:uage)?-([\w+#-]+)/i);
                    if (m2 && !window.hljs.getLanguage(m2[1])) return;
                    window.hljs.highlightElement(c);
                });
            };
            doc.head.appendChild(s);
        };
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                if (entries.some(function (e) { return e.isIntersecting; })) { load(); io.disconnect(); }
            }, {rootMargin: '600px 0px'});
            needsHighlight.forEach(function (c) { io.observe(c); });
        } else {
            load();
        }
    }

    /* Article series: number the parts, mark current, prev/next -------- */
    $$('.series-box').forEach(function (box) {
        var items = $$('.series-list li', box);
        if (!items.length) return;
        var cur = box.getAttribute('data-series-current');
        var idx = -1;
        items.forEach(function (li, i) {
            var a = li.querySelector('a');
            var num = doc.createElement('span');
            num.className = 'series-num';
            num.textContent = i + 1;
            a.insertBefore(num, a.firstChild);
            if (li.getAttribute('data-post-id') === cur) {
                idx = i;
                li.classList.add('is-current');
                a.setAttribute('aria-current', 'page');
            }
        });
        var slug = (box.getAttribute('data-series-slug') || '').replace(/^(hash-)?series-/, '').replace(/-/g, ' ');
        var name = slug.replace(/\b\w+/g, function (w) { return w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1); });
        var nameEl = $('.series-name', box);
        if (nameEl && name) nameEl.textContent = name;
        var pos = $('.series-pos', box);
        if (pos) pos.textContent = idx > -1 ? ' · part ' + (idx + 1) + ' of ' + items.length : '';
        var nav = $('.series-nav', box);
        if (nav && idx > -1 && items.length > 1) {
            var html = '';
            if (idx > 0) html += '<a class="btn btn-ghost btn-sm series-prev" href="' + items[idx - 1].querySelector('a').getAttribute('href') + '">&larr; Previous part</a>';
            if (idx < items.length - 1) html += '<a class="btn btn-sec btn-sm series-next" href="' + items[idx + 1].querySelector('a').getAttribute('href') + '">Next part &rarr;</a>';
            nav.innerHTML = html;
            nav.hidden = false;
        }
    });

    /* Image lightbox --------------------------------------------------- */
    var lb = $('.lightbox');
    if (lb) {
        var lbImgs = $$('img', content).filter(function (im) {
            return !im.closest('a') && !im.closest('.kg-bookmark-card') && im.naturalWidth !== 1;
        });
        if (lbImgs.length) {
            var lbImg = $('.lightbox-img', lb);
            var lbCap = $('.lightbox-caption', lb);
            var lbCount = $('.lightbox-count', lb);
            var lbPrev = $('.lightbox-prev', lb);
            var lbNext = $('.lightbox-next', lb);
            var lbIndex = 0;
            var lbItems = lbImgs.map(function (im) {
                var cap = '';
                var fig = im.closest('figure');
                if (fig) { var fc = fig.querySelector('figcaption'); if (fc) cap = fc.textContent; }
                var src = im.getAttribute('src');
                var ss = im.getAttribute('srcset');
                if (ss) { var last = ss.split(',').pop().trim().split(/\s+/)[0]; if (last) src = last; }
                return { src: src, alt: im.getAttribute('alt') || '', cap: cap };
            });
            var lbShow = function (i) {
                lbIndex = (i + lbItems.length) % lbItems.length;
                var it = lbItems[lbIndex];
                lbImg.src = it.src;
                lbImg.alt = it.alt;
                lbCap.textContent = it.cap;
                lbCap.hidden = !it.cap;
                var multi = lbItems.length > 1;
                lbCount.textContent = (lbIndex + 1) + ' / ' + lbItems.length;
                lbPrev.hidden = lbNext.hidden = lbCount.hidden = !multi;
            };
            var lbOpen = function (i) {
                lb.hidden = false;
                root.classList.add('lightbox-open');
                lbShow(i);
                $('.lightbox-close', lb).focus();
            };
            var lbClose = function () {
                lb.hidden = true;
                root.classList.remove('lightbox-open');
                lbImg.src = '';
            };
            lbImgs.forEach(function (im, i) {
                im.classList.add('has-lightbox');
                im.setAttribute('tabindex', '0');
                im.setAttribute('role', 'button');
                im.setAttribute('aria-label', 'View image full size');
                im.addEventListener('click', function () { lbOpen(i); });
                im.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lbOpen(i); } });
            });
            lb.addEventListener('click', function (e) {
                if (e.target.closest('[data-lb-close]')) lbClose();
                else if (e.target.closest('[data-lb-prev]')) lbShow(lbIndex - 1);
                else if (e.target.closest('[data-lb-next]')) lbShow(lbIndex + 1);
            });
            doc.addEventListener('keydown', function (e) {
                if (lb.hidden) return;
                if (e.key === 'Escape') lbClose();
                else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
                else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
            });
        }
    }

    /* External links in articles open safely in a new tab ---------------- */
    $$('a[href^="http"]', content).forEach(function (a) {
        if (a.hostname && a.hostname !== location.hostname) {
            a.setAttribute('target', '_blank');
            a.setAttribute('rel', 'noopener noreferrer');
            if (!a.closest('.kg-card')) a.classList.add('ext-link');
        }
    });

    /* Responsive tables -------------------------------------------------- */
    $$('table', content).forEach(function (t) {
        if (t.parentNode.classList.contains('table-wrap')) return;
        var w = doc.createElement('div');
        w.className = 'table-wrap';
        w.setAttribute('tabindex', '0');
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
    });

    if (reduceMotion) root.classList.add('reduce-motion');
})();
